import moment from "moment";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { downloadCsv } from "../../utils";

export const exporter = (data) => {
  const dataForExport = data.map((item) => ({
    "Usuário (Documento)": item.user ? item.user.document : "",
    Pergunta: item.survey ? item.survey.question : "",
    Resposta: item.optionSurvey ? item.optionSurvey.value : "",
    Lotes: item.survey ? item.survey.cycle.map(({ id }) => id).join(", ") : "",
    "Data de Criação": moment(item.createdAt).format("DD/MM/YYYY"),
  }));

  const csv = convertToCSV(
    {
      data: dataForExport,
      fields: ["Usuário (Documento)", "Pergunta", "Resposta", "Lotes", "Data de Criação"], 
    },
    {
      delimiter: ";",
    }
  );

  downloadCsv(csv, "answers");
};
